<template>
  <el-dialog
      :model-value="props.visible"
      title="详细信息"
      width="1150"
      top="6vh"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div class="base-wrap">
        <h3 class="info-title" v-if="!isOuterView">红字发票信息确认单状态：销方录入待购方确认</h3>

        <h4 class="info-txt">已选发票</h4>

        <main class="main-box">
          <el-row class="info-row" :gutter="20">
            <el-col :span="6">
              (销售方)纳税人名称:
            </el-col>
            <el-col :span="6">
              (销售方)统一社会信用代码/纳税人识别号 :
            </el-col>
            <el-col :span="6">
              (购买方)纳税人名称:
            </el-col>
            <el-col :span="6">
              (购买方)统一社会信用代码/纳税人识别号:
            </el-col>
          </el-row>

          <el-row class="info-row" :gutter="20">
            <el-col :span="6">
              {{ props.currentRow?.seller?.name }}
            </el-col>
            <el-col :span="6">
              {{ props.currentRow?.seller?.taxRegistrationNo }}
            </el-col>
            <el-col :span="6">
              {{ props.currentRow?.buyer?.name }}
            </el-col>
            <el-col :span="6">
              {{ props.currentRow?.buyer?.taxRegistrationNo }}
            </el-col>
          </el-row>

          <el-row class="info-row" :gutter="20">
            <el-col :span="6">
              开票日期:
            </el-col>
            <el-col :span="6">
              增值税用途状态:
            </el-col>
            <el-col :span="6">
              消费税用途状态:
            </el-col>
            <el-col :span="6">
              入账状态:
            </el-col>
          </el-row>

          <el-row class="info-row" :gutter="20">
            <el-col :span="6">
              {{ props.currentRow?.hzMakeDate }}
            </el-col>
            <el-col :span="6">
              {{ props.currentRow?.addUsageCheck }}
            </el-col>
            <el-col :span="6">
              {{ props.currentRow?.consumeUsageCheck }}
            </el-col>
            <el-col :span="6">
              {{ props.currentRow?.accountStatus }}
            </el-col>
          </el-row>

          <el-table
              ref="tableRef"
              max-height="calc(84vh - 380px)"
              :data="props.currentRow.originRows || []"
              class="red-confirm-table"
              style="margin-top: 10px;min-height: 200px;"
          >

            <el-table-column label="货物或应税劳务名称" align="center" prop="item.name" min-width="200"/>

            <el-table-column label="规格型号" align="center" prop="item.specification" min-width="200"/>

            <el-table-column label="单位" align="center" prop="item.unit" min-width="70"/>

            <el-table-column label="数量" align="center" prop="item.count" min-width="80"/>

            <el-table-column label="单价(不含税)" align="center" prop="item.price" min-width="110">
              <template #default="{row}">
                <span v-if="row.item?.price != null">{{ row.item.price.toFixed(2) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="金额(不含税)" align="center" prop="item.amount" min-width="110">
              <template #default="{row}">
                <span v-if="row.item?.amount != null">{{ row.item.amount.toFixed(2) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="税率" align="center" prop="item.rate" min-width="100"/>

            <el-table-column label="税额" align="center" prop="item.taxAmount" min-width="100">
              <template #default="{row}">
                <span v-if="row.item?.taxAmount != null">{{ row.item.taxAmount.toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>

          <div class="summary-wrap">
            <h3>合计</h3>
            <div class="grow"></div>
            <span class="summary-data">￥{{ props.currentRow?.item?.amount?.toFixed(2) }}</span>
            <span class="summary-data">￥{{ props.currentRow?.item?.taxAmount?.toFixed(2) }}</span>
          </div>

          <div class="summary-wrap">
            <div class="grow"></div>
            <span class="summary-data">价税合计（大写）：{{ props.currentRow?.item?.jsHj_Big }}</span>
            <span class="summary-data" style="padding-left: 30px;">价税合计（小写）：{{ props.currentRow?.item?.jsHj?.toFixed(2) }}</span>
          </div>
        </main>
      </div>

      <div class="my-footer" v-if="!isOuterView">
        <el-button type="primary" style="margin-left: 15px;" @click="onConfirm">确 认</el-button>
        <el-button @click="deny">拒 绝</el-button>
      </div>

      <div v-else style="height: 20px;"></div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage} from "element-plus";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  currentRow: {
    type: Object,
    default: () => {
    }
  },
  isOuterView: { // 是否为外面的列表查看
    type: Boolean,
    default: false
  }
})

const pageLoading = ref(false)

const tableList = ref([])

function onOpen() {

}


const emit = defineEmits(['update:visible', 'confirm', 'deny'])

async function onConfirm() {
  ElMessageBox.confirm("你要确认该红字发票吗？", "提示信息")
      .then(() => {
        ElMessage.success('确认成功')
        emit('confirm')
        emit('update:visible', false)
      })
      .catch(() => {
      })
}

function deny() {
  ElMessageBox.confirm("你要拒绝该红字发票吗?", "提示信息")
      .then(() => {
        ElMessage.success('拒绝成功')
        emit('deny')
        emit('update:visible', false)
      })
      .catch(() => {
      })
}

function closedModal() {
  emit('update:visible', false)
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}

.base-wrap {
  padding-top: 20px;

  .info-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #666666;
  }

  .info-txt {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 15px;
    color: #333333;
    margin-top: 10px;
  }

  .main-box {
    .info-row {
      line-height: 33px;
    }

    .summary-wrap {
      margin-top: 20px;
      border-top: 1px solid #ebeef5;
      display: flex;
      padding-top: 10px;

      .grow {
        flex-grow: 1;
      }

      .summary-data {
        min-width: 120px;
      }
    }
  }
}
</style>
